import React from 'react'
import { ScrollHeightBaseWrapper } from './ScrollHeightBaseStyled'
import { CustomScroll } from 'react-custom-scroll'
import PropTypes from 'prop-types'

const ScrollHeightBase = (props) => {
  const { children, height, padding } = props
  
  return (
    <ScrollHeightBaseWrapper height={height} padding={padding}>
      <CustomScroll heightRelativeToParent='100%'>
        {children}
      </CustomScroll>
    </ScrollHeightBaseWrapper>
  )
}
ScrollHeightBase.propTypes = {
  height: PropTypes.string,
  padding: PropTypes.string,
}
export default ScrollHeightBase